import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=0d486fc8&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=0d486fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d486fc8",
  null
  
)

export default component.exports